const ABIERTO = 'A'
const CERRADO = 'C'


const __dictionary = {
  [ABIERTO]: {
    id: ABIERTO,
    nombre: 'ABIERTO'
  },
  [CERRADO]: {
    id: CERRADO,
    nombre: 'CERRADO'
  }
}

const __array = [__dictionary[ABIERTO], __dictionary[CERRADO]]

export default Object.freeze({
  ABIERTO,
  CERRADO,
  __dictionary,
  __array
})
